module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Nesslau-Krummenau-5f71aea79a58b507682b595697045d2c.png";